<!-- 业务流程审批 -->
<template>
  <div class="threeLevelMain">
    <div class="queryBox clearfix">
      <div class="query_row">
        <div class="scan_box">
          <span class="sp_scan">公司名称：</span>
          <el-input
            class="ip_uniform_style"
            v-model="queryForm.corporate_name"
            size="mini"
            @input="searchHandle"
            clearable
          >
          </el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">品牌名：</span>
          <el-input
            class="ip_uniform_style"
            v-model="queryForm.brand_name"
            size="mini"
            @input="searchHandle"
            clearable
          >
          </el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">审核状态：</span>
          <el-select
            class="ip_uniform_style"
            v-model="queryForm.is_check"
            size="mini"
            @change="searchHandle"
            clearable
          >
            <el-option
              v-for="item in checkOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="btn_area_out">
        <el-button
          type="primary"
          size="mini"
          @click="resetSearch"
          icon="el-icon-refresh"
          >重置筛选</el-button
        >
      </div>
    </div>

    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{ width: 50 }"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="(e) => (resetPageNum = e)"
      :totalCount="totalCount"
    >
      <el-table-column
        slot="handle"
        label="操作"
        width="150"
        align="center"
        v-if="showApproveBtn"
      >
        <template slot-scope="{ row }">
          <el-button
            type="success"
            size="mini"
            plain
            @click="handlePass(row)"
            :disabled="row.is_check != '0'"
            >通过</el-button
          >
          <el-button
            type="danger"
            size="mini"
            plain
            @click="handleReject(row)"
            :disabled="row.is_check != '0'"
            >驳回</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        slot="is_check"
        label="状态"
        width="120"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <div v-if="row.is_check == '0'" class="fontColor_info">未审核</div>
          <div v-else-if="row.is_check == '1'" class="fontColor_success">
            已通过
          </div>
          <div v-if="row.is_check == '2'" class="fontColor_danger ellipsis">
            已驳回，原因：{{ row.cause }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        slot="update_time"
        label="审核时间"
        width="95"
        align="center"
      >
        <template slot-scope="{ row }">
          <div v-if="row.verifier">
            {{ row.update_time }}
          </div>
        </template>
      </el-table-column>
    </tablePageComp>

    <!-- 驳回原因填写 -->
    <el-dialog title="驳回原因" :visible.sync="rejectVis" width="500px">
      <el-input type="textarea" v-model="rejectForm.cause" :rows="3"></el-input>
      <span slot="footer">
        <el-button @click="rejectVis = false" :loading="btnLoading" size="mini">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="subBtn"
          :loading="btnLoading"
          size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "reviewProcess",
  props: {
    showApproveBtn: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      queryForm: {
        corporate_name: "",
        brand_name: "",
        is_check: "",
      },
      totalCount: 0,
      columnsList: [
        {
          label: "操作",
          slotName: "handle",
        },
        {
          label: "状态",
          slotName: "is_check",
        },
        {
          label: "公司名",
          prop: "corporate_name",
        },
        {
          label: "品牌名",
          prop: "brand_name",
        },
        {
          label: "合同到期时间",
          prop: "due_time",
          formatter: (val) => val.split(" ")[0],
        },
        {
          label: "延期天数",
          prop: "deferred_days",
        },
        {
          label: "延期日期",
          prop: "deferred_time",
        },
        {
          label: "申请人",
          prop: "applicant",
          formatter: (val) => this.$tools.conversionName(val),
        },
        {
          label: "申请时间",
          prop: "create_time",
          width: 95,
        },
        {
          label: "审核人",
          prop: "verifier",
          formatter: (val) => this.$tools.conversionName(val),
        },
        {
          label: "审核时间",
          slotName: "update_time",
        },
      ],
      dataList: [],
      updateDataTag: false,
      resetPageNum: true,
      checkOptions: [
        {
          label: "未审核",
          value: "0",
        },
        {
          label: "审核通过",
          value: "1",
        },
        {
          label: "驳回",
          value: "2",
        },
      ],
      rejectVis: false,
      rejectForm: {},
      btnLoading: false,
    };
  },
  methods: {
    handlePass(row) {
      this.$confirm("确认通过这条申请吗?", "提示", {
        type: "warning",
        lock: true,
      }).then(() => {
        this.btnLoading = true;
        let paramObj = {
          verifier: this.$store.state.userId, // 操作人
          is_check: "1",
          // 通知用
          corporate_name: row.corporate_name,
          applicant: row.applicant,
          id: row.id,
        };
        this.$api
          .modifyDeferApplyFunc(paramObj)
          .then((res) => {
            this.resetPageNum = false;
            this.updateDataTag = !this.updateDataTag;
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    handleReject(row) {
      this.rejectForm = {
        cause: "",
        corporate_name: row.corporate_name,
        applicant: row.applicant,
        id: row.id,
      };
      this.rejectVis = true;
    },
    subBtn() {
      if (!this.rejectForm.cause) {
        this.$message.warning("请填写驳回原因");
        return;
      }
      this.btnLoading = true;
      this.$api
        .modifyDeferApplyFunc({
          is_check: "2",
          verifier: this.$store.state.userId, // 操作人
          ...this.rejectForm,
        })
        .then((res) => {
          this.resetPageNum = false;
          this.updateDataTag = !this.updateDataTag;
          this.rejectVis = false;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    searchHandle() {
      this.$tools.debounceFunc(() => {
        this.updateDataTag = !this.updateDataTag;
      });
    },
    resetSearch() {
      Object.keys(this.queryForm).forEach((key) => {
        this.queryForm[key] = "";
      });
      this.updateDataTag = !this.updateDataTag;
    },
    dataQueryFunc() {
      let paramObj = {
        ...this.queryForm,
      };
      // 娜姐可查看所有流程申请
      if (!this.showApproveBtn && this.$store.state.userId != "33") {
        paramObj.applicant = this.$store.state.userId;
      }
      return {
        apiName: "getDeferredApplyFuc",
        paramObj,
        success: (res, callback) => {
          // console.log(res);
          this.dataList = res.data.data.list;

          this.totalCount = res.data.data.count;
          // id=13 ，禁止查看所有流程申请
          if (this.$store.state.userId == "13") {
            this.dataList = [];
            this.totalCount = 0;
          }
          if (callback) callback();
        },
        failed: (error, callback) => {
          console.log(error);
          if (callback) callback();
        },
      };
    },
  },
  created() {
    // 工作台待办进入
    let param = this.$route.params;
    if (JSON.stringify(param) != "{}") {
      Object.keys(param).forEach((key) => {
        if (key != "view") {
          this.queryForm[key] = param[key];
        }
      });
    }
  },
};
</script>

<style></style>
